import type React from "react";
import {memo} from "react";

import {Divider} from "../ui/divider";
import {HStack} from "../ui/hstack";
import {Text} from "../ui/text";

type Props = {
    text: string;
};

const DividerWithText: React.FC<Props> = ({text}) => {
    return (
        <HStack className="items-center" space="2xl">
            <Divider className="flex-1" />
            <Text variant="md">{text}</Text>
            <Divider className="flex-1" />
        </HStack>
    );
};

export default memo(DividerWithText);
